export default __webpack_public_path__ + "media/images/gallery/33-f4cdb4962928a6410bd06ab3e55c79d5.jpg";